import { FORMAT_DATE_DEFAULT, FORMAT_TIME_DEFAULT } from "@/common/datetime/TimeFunction";

export class SettingResponseModel {
  guid: string;
  language: string;
  isAssistantOrganizer: boolean;
  emailAssistantOrganizer: string;
  emailFlowAssistantOrganizer: string;
  dateTimeFormat: DateTimeFormat;
  defaultLocation: string;
  defaultCategories: string;
  organizationId: string;
  tenantId: string;

  constructor(data: ISettingResponseModel) {
    this.guid = data.guid;
    this.language = data.language || "";
    this.isAssistantOrganizer = !!data.isAssistantOrganizer;
    this.emailAssistantOrganizer = data.emailAssistantOrganizer || "";
    this.dateTimeFormat = new DateTimeFormat({
      firstDayOfWeek: data.firstDayOfWeek,
      timeFormat: data.timeFormat,
      dateFormat: data.dateFormat,
      dateSeparator: data.dateSeparator,
    });
    this.defaultLocation = data.defaultLocation || "";
    this.defaultCategories = data.defaultCategories || "";
    this.organizationId = data.organizationId || "";
    this.tenantId = data.tenantId || "";
    this.emailFlowAssistantOrganizer = data.emailFlowAssistantOrganizer || "";
  }

  toJson(): ISettingResponseModel {
    return {
      guid: this.guid,
      language: this.language,
      isAssistantOrganizer: this.isAssistantOrganizer,
      emailAssistantOrganizer: this.emailAssistantOrganizer,
      emailFlowAssistantOrganizer: this.emailFlowAssistantOrganizer,
      firstDayOfWeek: this.dateTimeFormat.firstDayOfWeek,
      timeFormat: this.dateTimeFormat.timeFormat,
      dateFormat: this.dateTimeFormat.dateFormat,
      dateSeparator: this.dateTimeFormat.dateSeparator,
      defaultLocation: this.defaultLocation,
      defaultCategories: this.defaultCategories,
      organizationId: this.organizationId,
      tenantId: this.tenantId,
    };
  }
}

export interface ISettingResponseModel {
  guid: string;
  language: string;
  isAssistantOrganizer: boolean;
  emailAssistantOrganizer: string;
  emailFlowAssistantOrganizer: string;
  firstDayOfWeek: string;
  timeFormat: string;
  dateFormat: string;
  dateSeparator: string;
  defaultLocation: string;
  defaultCategories: string;
  organizationId: string;
  tenantId: string;
}

export interface IDateTimeFormat {
  firstDayOfWeek?: string;
  timeFormat?: string;
  dateFormat?: string;
  dateSeparator?: string;
}

export class DateTimeFormat {
  firstDayOfWeek: string;
  timeFormat: string;
  dateFormat: string;
  dateSeparator: string;

  constructor(data?: IDateTimeFormat) {
    this.firstDayOfWeek = String(data?.firstDayOfWeek) || "0";
    this.timeFormat = data?.timeFormat || FORMAT_TIME_DEFAULT;
    this.dateFormat = data?.dateFormat || FORMAT_DATE_DEFAULT;
    this.dateSeparator = data?.dateSeparator || "-";
  }

  get dateTimeSeparator(): string {
    const datetimeFormatClone = this.dateFormat.replaceAll(
      "-",
      this.dateSeparator
    );
    return datetimeFormatClone;
  }

  toJson(): IDateTimeFormat {
    return {
      firstDayOfWeek: this.firstDayOfWeek,
      timeFormat: this.timeFormat,
      dateFormat: this.dateFormat,
      dateSeparator: this.dateSeparator,
    };
  }
}
